module.exports = __webpack_public_path__ + "static/media/unique-challenge-caterer.318e5ddc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/unique-challenge-caterer.jpg
// module id = 1585
// module chunks = 0